const RES_SAVING = "RES_SAVING"
const RES_SAVING_SUCCESS = "RES_SAVING_SUCCESS"
const RES_SAVING_ERROR = "RES_SAVING_ERROR"
const RES_FETCHING_RESET = "RES_FETCHING_RESET"
const RES_FETCHING_RESET_SUCCESS = "RES_FETCHING_RESET_SUCCESS"
const RES_FETCHING_RESET_ERROR = "RES_FETCHING_RESET_ERROR"
const RES_FETCHING_IS_STUDENT = "RES_FETCHING_IS_STUDENT"
const RES_FETCHING_IS_STUDENT_SUCCESS = "RES_FETCHING_IS_STUDENT_SUCCESS"
const RES_FETCHING_IS_STUDENT_ERROR = "RES_FETCHING_IS_STUDENT_ERROR"

export function fetchingIsStudent() {
  return {
    type: RES_FETCHING_IS_STUDENT
  }
}

export function fetchingIsStudentSuccess(isStudent) {
  return {
    type: RES_FETCHING_IS_STUDENT_SUCCESS,
    isStudent
  }
}

export function fetchingIsStudentError(error) {
  return {
    type: RES_FETCHING_IS_STUDENT_ERROR,
    error
  }
}

export function fetchingReset() {
  return {
    type: RES_FETCHING_RESET
  }
}

export function fetchingResetSuccess(reset) {
  return {
    type: RES_FETCHING_RESET_SUCCESS,
    reset
  }
}

export function fetchingResetError(error) {
  return {
    type: RES_FETCHING_RESET_ERROR,
    error
  }
}

export function saving() {
  return {
    type: RES_SAVING
  }
}

export function savingSuccess() {
  return {
    type: RES_SAVING_SUCCESS
  }
}

export function savingError(error) {
  return {
    type: RES_SAVING_ERROR,
    error
  }
}

const initialState = {
  isSaving: false,
  isSavingError: "",
  isFetchingReset: false,
  isFetchingResetError: "",
  reset: null,
  isStudent: false,
  isFetchingIsStudent: false,
  isFetchingIsStudentError: false,
  isFetchingIsStudentErrorContent: ""
}

export function resets(state = initialState, action) {
  switch (action.type) {
    case RES_FETCHING_IS_STUDENT:
      return {
        ...state,
        isFetchingIsStudent: true
      }
    case RES_FETCHING_IS_STUDENT_SUCCESS:
      return {
        ...state,
        isFetchingIsStudent: false,
        isStudent: action.isStudent
      }
    case RES_FETCHING_IS_STUDENT_ERROR:
      return {
        ...state,
        isFetchingIsStudent: false,
        isFetchingIsStudentErrorContent: action.error,
        isFetchingIsStudentError: true
      }
    case RES_SAVING_SUCCESS:
      return {
        ...state,
        isSaving: false
      }
    case RES_SAVING_ERROR:
      return {
        ...state,
        isSaving: false,
        isSavingError: action.error
      }
    case RES_FETCHING_RESET:
      return {
        ...state,
        isFetchingReset: true
      }
    case RES_FETCHING_RESET_SUCCESS:
      return {
        ...state,
        isFetchingReset: false,
        reset: action.reset
      }
    case RES_FETCHING_RESET_ERROR:
      return {
        ...state,
        isFetchingReset: false,
        isFetchingResetError: action.error,
        isFetchingIsStudent: false
      }
    case RES_SAVING:
      return {
        ...state,
        isSaving: "true"
      }
    default:
      return state
  }
}
